/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Select } from 'antd';
import Utils from '../../redux/utils';
import {
  Page,
  Breadcrumb,
  Button,
  ListCount,
  SearchBox,
  IconSwitcher,
  SyncPreferences,
  ResponseDialog,
} from '../../components';
import BranchActions from '../../redux/middleware/branches';
import BrandActions from '../../redux/middleware/brands';
import MenuActions from '../../redux/middleware/menu';
import UsersApi from '../../redux/middleware/users';
import ComboActions from '../../redux/middleware/combo';
import RecipeApiActions from '../../redux/middleware/recipe-api';
import SubRecipeActions from '../../redux/middleware/subRecipe';
import SupplierApi from '../../redux/middleware/supplier';
import Export from '../../assets/images/export.png';
import { useSelector } from 'react-redux';
import { checkAuthentication } from '../../helper/checkAuthentication';
import { useTranslation } from 'react-i18next';

const TestPage = () => {
  const user = Utils.getCurrentUser();
  const { t } = useTranslation('translation', {
    keyPrefix: 'menuPage',
  });
  const brand = Utils.getCurrentBrand();
  const [loader, setLoader] = useState(false);
  const [design, setDesign] = useState(true);
  const [current, setCurrent] = useState(1);
  const [sortData, setSortData] = useState([{}]);
  const [menu, setMenu] = useState([{}]);
  const [menuBarFilter, setMenuBarFilter] = useState<any>();
  const [dataLength, setDataLength] = useState(50);
  const [total, setTotal] = useState(0);
  const [recipeLoader, setRecipeLoader] = useState(false);
  const [recipeCount, setRecipeCount] = useState(0);
  const [ingrdientCount, setIngredientCount] = useState(0);
  const [menuStatus, setMenuStatus] = useState('ALL');
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const { currentBrand, currentShop } = useSelector((state: any) => state.Auth);
  const [allowRequest, setAllowRequest] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [currentBrandId, setCurrentBrandId] = useState(currentBrand?.brand_id);
  const [openDialogForSync, setOpenDialogForSync] = React.useState(false);
  const userRole = Utils.getUserRole()?.id;
  const toggleRef = React.useRef(null as any);
  toggleRef.current = false;

  useEffect(() => {
    if (currentBrandId !== currentBrand?.brand_id) {
      setKeyword('');
      setAllowRequest(true);
    }
  }, [currentBrand, currentShop]);

  useEffect(() => {
    const fetchAllData = () => {
      pageData();
      pageDataUser();
      pageDataBrands();
      pageDataCombos();
      pageDataRecipe();
      pageDataBranches();
      pageDataInventory();
      pageDataSubRecipes();
    };
    let callCount = 0;
    const maxCalls = 3;
    fetchAllData();
    callCount++;
    const timer = setInterval(() => {
      if (callCount < maxCalls) {
        fetchAllData();
        callCount++;
      } else {
        clearInterval(timer);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    checkAuthentication(user, navigate);
    if (dataLength && current) {
      setCurrentBrandId(currentBrand?.brand_id);
      pageData();
    }
  }, [dataLength, current, currentBrand]);

  const openInNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleCookBook = async () => {
    setLoader(true);
    const response = await RecipeApiActions.exportBrandBookMenu();
    const { success, data } = response;
    let responseDialogData;
    if (success) {
      openInNewTab(data);
    } else {
      responseDialogData = {
        OnClick: () => {},
        type: 'error',
        messageArray: [`${response?.message}`],
      };
      ResponseDialog(responseDialogData);
    }
    setLoader(false);
  };

  const getFilteredMenuItems = async (status: any, menuCategory?: number) => {
    const menuData = await MenuActions.getActiveInactiveMenu(
      dataLength,
      current,
      currentBrand?.brand_id || brand?.brand_id,
      keyword,
      status,
      menuCategory ? menuCategory : ''
    );
    if (menuData === undefined || !menuData?.success) {
      setRecipeCount(0);
      setIngredientCount(0);
      setTotal(0);
      setSortData([]);
    } else {
      const { items } = menuData?.data || null;
      if (items?.length > 0) {
        setRecipeCount(menuData?.data?.menu_count);
        setIngredientCount(menuData?.data?.ingredients_count);
        setTotal(menuData?.data?.pagination?.total);
        setMenu(menuData?.data?.items);
        setSortData(menuData?.data?.items);
      }
    }
    setRecipeLoader(false);
  };

  const pageData = async () => {
    const brand = await Utils.getCurrentBrand();
    setRecipeLoader(true);
    const menuData = await MenuActions.getManageMenu(
      dataLength,
      current,
      currentBrand?.brand_id || brand?.brand_id,
      keyword
    );
    if (menuData === undefined || !menuData?.success) {
      setRecipeCount(0);
      setIngredientCount(0);
      setTotal(0);
      setSortData([]);
    } else {
      const { items } = menuData?.data || null;
      if (items?.length > 0) {
        // const filterList = items.filter((x: any) => x.item_type != 'combo');
        setMenuStatus('ALL');
        setRecipeCount(menuData?.data?.menu_count);
        setIngredientCount(menuData?.data?.ingredients_count);
        setTotal(menuData?.data?.pagination?.total);
        setMenu(menuData?.data?.items);
        setSortData(menuData?.data?.items);
      }
    }
    setRecipeLoader(false);
  };

  const pageDataBrands = async () => {
    setLoader(true);
    const Data = await BrandActions.getBrands(dataLength, current, search);
    if (Data == undefined || !Data?.success) {
      setTotal(0);
      setSortData([]);
    } else {
      setTotal(Data?.data?.pagination?.total);
      setSortData(Data?.data?.items);
    }
    setLoader(false);
  };

  const pageDataBranches = async () => {
    setLoader(true);
    const brand = await Utils.getCurrentBrand();
    const Data = await BranchActions.getShops(
      dataLength,
      current,
      currentBrand?.brand_id || brand?.brand_id,
      keyword
    );
    if (Data == undefined || !Data?.success) {
      setTotal(0);
      setSortData([]);
    } else {
      setTotal(Data?.data?.pagination?.total);
      setSortData(Data?.data?.items);
    }
    setLoader(false);
  };

  const pageDataInventory = async () => {
    let request_id;
    setRecipeLoader(true);
    const shop = await Utils.getCurrentShop();
    const brand = await Utils.getCurrentBrand();
    const { success, data } = await SupplierApi.getSupplyStatus('request_type');

    if (success)
      request_id = data?.find((supply: any) => supply?.slug == 'cash_purchase');
    const imagesData = await SubRecipeActions.getAllInventory(
      3,
      1,
      1000,
      brand?.brand_id || 0,
      shop?.shop_id || 0
    );

    if (imagesData === undefined || !imagesData?.success) {
      setTotal(0);
    } else {
      setTotal(imagesData?.data?.pagination?.total);
    }
    setRecipeLoader(false);
  };

  const pageDataCombos = async () => {
    setRecipeLoader(true);
    const recipeData = await ComboActions.getCombos(
      dataLength,
      current,
      keyword
    );
    if (recipeData === undefined || !recipeData?.success) {
      setRecipeCount(0);
      setTotal(0);
      setSortData([]);
    } else {
      setRecipeCount(recipeData?.data?.combo_count);
      setTotal(recipeData?.data?.pagination?.total);
      setSortData(recipeData?.data?.items);
    }
    setRecipeLoader(false);
  };

  const onSearch = async (keyword: string) => {
    setSearch(keyword);
    setRecipeLoader(true);
    const searchResultofRecipes =
      menuStatus === 'ALL'
        ? await MenuActions.searchMenuAll(dataLength, current, keyword)
        : await MenuActions.searchMenuWRTStatus(
            dataLength,
            current,
            keyword,
            menuStatus !== 'ALL' ? menuStatus : ''
          );
    const { success } = searchResultofRecipes;
    if (!success) {
      setRecipeCount(0);
      setIngredientCount(0);
      setTotal(0);
      setSortData([]);
    } else {
      setRecipeCount(searchResultofRecipes?.data?.menu_count);
      setIngredientCount(searchResultofRecipes?.data?.ingredients_count);
      setTotal(searchResultofRecipes?.data?.pagination?.total);
      const { items } = searchResultofRecipes?.data || null;
      if (items?.length > 0 && keyword === '') {
        const filterList = items.filter((x: any) => x.item_type != 'combo');
        setSortData(filterList || searchResultofRecipes?.data?.items);
      } else {
        setSortData(searchResultofRecipes?.data?.items);
      }
    }
    setRecipeLoader(false);
  };

  const pageDataRecipe = async () => {
    const brand = await Utils.getCurrentBrand();
    setRecipeLoader(true);
    const recipeData = await RecipeApiActions.getRecipes(
      dataLength,
      current,
      currentBrand?.brand_id || brand?.brand_id,
      keyword
    );
    if (recipeData == undefined || !recipeData?.success) {
      setRecipeCount(0);
      setIngredientCount(0);
      setTotal(0);
      setSortData([]);
    } else {
      const items = recipeData?.data?.items || [];
      setSortData(items);
      setRecipeCount(recipeData?.data?.recipe_count);
      setIngredientCount(recipeData?.data?.ingredients_count);
      setTotal(recipeData?.data?.pagination?.total);
    }
    setRecipeLoader(false);
  };

  const pageDataSubRecipes = async () => {
    const brand = await Utils.getCurrentBrand();
    setRecipeLoader(true);
    const SubRecipeData = await SubRecipeActions.getSubRecipes(
      dataLength,
      current,
      currentBrand?.brand_id || brand?.brand_id,
      keyword
    );

    if (SubRecipeData == undefined || !SubRecipeData?.success) {
      setRecipeCount(0);
      setIngredientCount(0);
      setTotal(0);
      setSortData([]);
    } else {
      setRecipeCount(SubRecipeData?.data?.recipe_count);
      setIngredientCount(SubRecipeData?.data?.ingredients_count);
      setTotal(SubRecipeData?.data?.pagination?.total);
      setSortData(SubRecipeData?.data?.items);
    }
    setRecipeLoader(false);
  };

  const pageDataUser = async () => {
    setRecipeLoader(true);
    const shop = await Utils.getCurrentShop();
    const brand = await Utils.getCurrentBrand();
    const user = await Utils.getCurrentUser();
    const userData = await UsersApi.getUsers(
      dataLength,
      current,
      user?.roles[0]?.id === 1 ? '' : brand?.brand_id || currentBrand?.brand_id,
      keyword
    );
    if (userData === undefined || !userData?.success) {
      setTotal(0);
      setSortData([]);
    } else {
      setTotal(userData?.data?.pagination?.total);
      setSortData(userData?.data?.items);
    }
    setRecipeLoader(false);
  };

  const actionButton = () => {
    const { integrations } = Utils.getCurrentBrand();
    const { id } = Utils.getUserRole();
    const isFoodicsIntegrated = integrations.length > 0;
    // TODO: Add this for Live Build
    // if (id === 3) return null;
    return (
      <Button
        text="Sync Preferences"
        className="theme-button recipeBtn"
        handleButtonClick={() => {
          setOpenDialogForSync(true);
        }}
        shape="round"
        size="middle"
        disabled={!isFoodicsIntegrated}
        title={
          !isFoodicsIntegrated
            ? 'Your current Brand does not have Foodics Integration'
            : ''
        }
      />
    );
  };

  const onSwitch = () => {
    pageData();
  };

  return (
    <div className="menuPage">
      {openDialogForSync ? (
        <SyncPreferences
          open={openDialogForSync}
          handleCancel={() => setOpenDialogForSync(false)}
          component="Sync-Preferences"
        />
      ) : null}
      <Breadcrumb
        heading="Menu"
        breadcrumbIcon
        iconAction={() => {
          navigate('/app/Dashboard');
        }}
        button={userRole === 3 ? actionButton() : null}
      />
      <Page title="Dashboard">
        <Row className="listingTopFilter">
          <Col lg={2} md={24}>
            <ListCount count1={recipeCount} title1="Total Menu" />
          </Col>
          <Col lg={8} md={24} className="brand-filter-container">
            <Select
              size="large"
              placeholder="Menu Status"
              value={menuStatus}
              style={{ width: 160 }}
              onChange={(value) => {
                setMenuStatus(value);
                if (value === 'ALL') {
                  pageData();
                } else if (value === '1') {
                  getFilteredMenuItems(1, menuBarFilter);
                } else if (value === '0') {
                  getFilteredMenuItems(0, menuBarFilter);
                }
              }}
            >
              <Select.Option key="ALL" value="ALL">
                ALL Items
              </Select.Option>
              <Select.Option key="1" value="1">
                Active
              </Select.Option>
              <Select.Option key="0" value="0">
                Non Active
              </Select.Option>
            </Select>
          </Col>
          <Col lg={14} md={24}>
            <div className="search-wrapper">
              <div className="search-box">
                <SearchBox
                  keyword={keyword}
                  setKeyword={setKeyword}
                  action={onSearch}
                  placeholderText="Search..."
                />
              </div>
              <div className="exportButtonForCookBook" onClick={handleCookBook}>
                <img src={Export} alt="" />
                <div className="exportText"> Menu Costings</div>
              </div>
              {/* <div className="exportButton">
                <img src={Export} alt="" />
                <div className="exportText"> Export</div>
              </div> */}
              <IconSwitcher
                component="menu"
                listViewLayout={design}
                setListView={setDesign}
                onClick={onSwitch}
              />
            </div>
          </Col>
        </Row>
      </Page>
    </div>
  );
};

export default TestPage;
